import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ChecklistEntregaAmbienteModel } from "../../../../domain/models/checklist_entrega_ambiente";
import { ChecklistEntregaAmbienteCopiaForm, ChecklistEntregaAmbienteCopiaSchema, defaultChecklistEntregaAmbienteCopiaForm } from "../../../schemas/checklist_entrega_ambiente_lista/checklistEntregaAmbienteCopia";

type props = {
    open: boolean,
    saving: boolean,
    selectedChecklistEntregaAmbiente?: ChecklistEntregaAmbienteModel | null,

    onClose: () => void,
    onSubmit: (form: ChecklistEntregaAmbienteCopiaForm) => void,
}

export const CopiaChecklistEntregaAmbienteModal = ({
    open,
    saving,
    selectedChecklistEntregaAmbiente,
    onClose,
    onSubmit,

}: props) => {

    const hookFormCopia = useForm<ChecklistEntregaAmbienteCopiaForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultChecklistEntregaAmbienteCopiaForm,
        resolver: zodResolver(ChecklistEntregaAmbienteCopiaSchema),
    });

    useEffect(() => {
        if (selectedChecklistEntregaAmbiente) {
            hookFormCopia.setValue('idChecklistEntrega', selectedChecklistEntregaAmbiente.idChecklistEntrega);
            hookFormCopia.setValue('ordem', selectedChecklistEntregaAmbiente.ordem ?? "");
            hookFormCopia.setValue('descricao', selectedChecklistEntregaAmbiente.descricao ?? "");
        }

    }, [selectedChecklistEntregaAmbiente, hookFormCopia]);

    const handleSubmit = useCallback((form: ChecklistEntregaAmbienteCopiaForm) => {
        if (!saving) {
            onSubmit(form);
            hookFormCopia.reset();
        }

    }, [saving, onSubmit, hookFormCopia]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookFormCopia.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Copiar Checklist de Entrega
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <DefaultFormInput
                                name='ordem'
                                label='Ordem'
                                readOnly={false}
                                required={true}
                                reactHookForm={hookFormCopia}

                            />

                            <DefaultFormInput
                                name={'descricao'}
                                label="Descrição"
                                readOnly={false}
                                required={true}
                                multiline={true}
                                rows={5}
                                minRows={4}
                                maxRows={10}
                                reactHookForm={hookFormCopia}
                            />
                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    );
}